import { ButtonGroupProps } from './ButtonGroup.types';
import { getClasses } from '@/_utils/classnames';
import { Flex } from '@/_components';
import styles from './ButtonGroup.module.css';
import type { FC } from 'react';

export const ButtonGroup: FC<ButtonGroupProps> = ({
  className,
  children,
  align = 'left',
  isSmallGroup,
  isSameLine,
  isFullWidth,
}) => {
  const buttonGroupClasses: string = getClasses(styles.buttonGroup, {
    [styles.buttonGroupLeft]: align === 'left',
    [styles.buttonGroupCenter]: align === 'center',
    [styles.buttonGroupSpaceBetween]: align === 'space-between',
    [styles.buttonGroupRight]: align === 'right',
    [styles.buttonGroupFullWidth]: isFullWidth,
    [`${className}`]: !!className,
  });

  return (
    <Flex
      className={buttonGroupClasses}
      gap={isSmallGroup ? 4 : 6}
      isYCentered={true}
      data-component="ButtonGroup"
      isWrapping={!isSameLine}
    >
      {children}
    </Flex>
  );
};
